export default __webpack_public_path__ + "static/media/dark-circled-tick.3cf74239.svg";